// extracted by mini-css-extract-plugin
module.exports = {"toggler":"MobileMenuToggler_toggler__2IAXS","hamburger":"MobileMenuToggler_hamburger__DF1T-","label":"MobileMenuToggler_label__1YH04"};